import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingImageCompressorConfig } from '@/data/landingConfig/landingImageCompressorConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageCompressor } from './schemaObject';

interface Props {}
const ImageCompressor: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageCompressorV2,
		},
		GenerateLandingLinkService.funnelImageCompressor,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_ImageCompressor} />
			<LandingTemplate
				data={landingImageCompressorConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageCompressor;
